import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

// ----------------------------------------------- Office----------------------------------------------------
export const getSocialConfig = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/config`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};


export const createAndUpdateSocialConfig = async ( body) => {
    try {

        const formData = new FormData()
        formData.append('link_social_1', body.link_social_1)
        formData.append('link_social_2', body.link_social_2)
        formData.append('link_social_3', body.link_social_3)
        formData.append('link_social_4', body.link_social_4)
        formData.append('link_social_5', body.link_social_5)

        if (body.img_social_1.length > 0) {
            if(body.img_social_1[0].file?.file){
                const blob = new Blob([body.img_social_1[0].file?.file], { type: body.img_social_1[0].file?.file.type });
                const parts = body.img_social_1[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.img_social_1[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.img_social_1[0].file.size
                });

                formData.append('img_social_1', file)
            }
            else{
                formData.append('img_social_1', body.img_social_1[0].file)
            }
        }else{
            formData.append('img_social_1', null)
        }
        
        if (body.img_social_2.length > 0) {
            if(body.img_social_2[0].file?.file){
                const blob = new Blob([body.img_social_2[0].file?.file], { type: body.img_social_2[0].file?.file.type });
                const parts = body.img_social_2[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.img_social_2[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.img_social_2[0].file.size
                });

                formData.append('img_social_2', file)
            }
            else{
                formData.append('img_social_2', body.img_social_2[0].file)
            }
        }else{
            formData.append('img_social_2', null)
        }

        if (body.img_social_3.length > 0) {
            if(body.img_social_3[0].file?.file){
                const blob = new Blob([body.img_social_3[0].file?.file], { type: body.img_social_3[0].file?.file.type });
                const parts = body.img_social_3[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.img_social_3[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.img_social_3[0].file.size
                });

                formData.append('img_social_3', file)
            }
            else{
                formData.append('img_social_3', body.img_social_3[0].file)
            }
        }else{
            formData.append('img_social_3', null)
        }

        if (body.img_social_4.length > 0) {
            if(body.img_social_4[0].file?.file){
                const blob = new Blob([body.img_social_4[0].file?.file], { type: body.img_social_4[0].file?.file.type });
                const parts = body.img_social_4[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.img_social_4[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.img_social_4[0].file.size
                });

                formData.append('img_social_4', file)
            }
            else{
                formData.append('img_social_4', body.img_social_4[0].file)
            }
        }else{
            formData.append('img_social_4', null)
        }

        if (body.img_social_5.length > 0) {
            if(body.img_social_5[0].file?.file){
                const blob = new Blob([body.img_social_5[0].file?.file], { type: body.img_social_5[0].file?.file.type });
                const parts = body.img_social_5[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.img_social_5[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.img_social_5[0].file.size
                });

                formData.append('img_social_5', file)
            }
            else{
                formData.append('img_social_5', body.img_social_5[0].file)
            }
        }else{
            formData.append('img_social_5', null)
        }

        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        let response = null 
        response = await instance.post(`/api/mgr/config`, formData, {
            headers: headers,
        });
     
        return response;

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};
